// extracted by mini-css-extract-plugin
module.exports = {"X":"X_X__25fxN"};